/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


<!-- Inicio javascript do seletor de quantidade -->
$(document).ready(function() {
  var $buttonPlus = $('.qtyplus');
  var $buttonMin = $('.qtyminus');
  var $quantity = $('.qty');
  
  /*For plus and minus buttons*/
  $buttonPlus.click(function() {
    $quantity.val(parseInt($quantity.val()) + 1).trigger('input');
  });
  
  $buttonMin.click(function() {
    $quantity.val(Math.max(parseInt($quantity.val()) - 1, 0)).trigger('input');
  });
})
<!-- Final javascript do seletor de quantidade -->

if (window.matchMedia("(max-width: 768px)").matches) {
  window.addEventListener('scroll', function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) {
      if (pageOffset > 1200) {
        btn.style.display = 'block';
      } else {
        btn.style.display = 'none';
      }
      // Esconde o botão ao voltar ao topo
      if (pageOffset < 1) {
        btn.style.display = 'none';
      }
    }
  });
  // Oculta o botão no carregamento inicial
  var btn = document.getElementById('scrollToTop');
  if (btn) btn.style.display = 'none';
}

   // Script personalizar seletor suspenso

        $("select.product-form__single-selector").change(function(){
          $(this).val()==="Sim Quero Personalizar" ? $(".personalizacao").show() : $(".personalizacao").hide();
        }).trigger("change");
        
        $(".block-swatch__radio").change(function(){
          $(this).val()==="Sim Quero Personalizar" ? $(".personalizacao").show() : $(".personalizacao").hide();
        });

   // Script personalizar seletor dropdown

        $(document).ready(function(){
          // Função para atualizar a exibição da área de personalização
          function updatePersonalizacao(value) {
            if (value === "Sim Quero Personalizar") {
              $(".personalizacao").show();
            } else if (value === "Não") {
              $(".personalizacao").hide();
            }
          }
        
          // Verifica o valor inicial dos radios marcados
          $(".block-swatch__radio:checked").each(function(){
            updatePersonalizacao($(this).val());
          });
        
          // Atualiza quando houver mudança na seleção dos radios
          $(".block-swatch__radio").on("change", function(){
            updatePersonalizacao($(this).val());
          });
        });




